import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 700px;

  .inner {
    display: block;
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = ['ASP.NET Core', 'React', 'TypeScript', 'PostgreSQL', 'Node.js', 'Python'];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              Hello! I'm Abdullah, a Computer Science student at{' '}
              <a href="https://www.uet.edu.pk/">UET Lahore</a>, graduating in 2026. My journey in
              software development spans enterprise FinTech applications, AI-powered document
              processing, and full-stack web development.
            </p>

            <p>
              During my internship at <a href="https://www.directfn.com/">DirectFN</a>, I
              contributed to enterprise financial applications like EdaaConnect and Alfalah
              Investments, working with React and ASP.NET. I'm a{' '}
              <a href="https://www.mckinsey.com/forward/overview">McKinsey Forward Program</a>{' '}
              graduate and Oracle Cloud certified professional.
            </p>

            <p>
              Currently, I'm building <a href="https://oneversity.net">OneUni</a> — an EdTech
              platform that simplifies university admissions for students across Pakistan, featuring
              AI-powered prospectus extraction and personalized mentorship matching.
            </p>

            <p>Here are a few technologies I've been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>
      </div>
    </StyledAboutSection>
  );
};

export default About;
